<div id="coAppInviteOuterDiv" class="co-app-invite" *transloco="let t">
	<div *ngIf="!showSplashScreen">
		<op-masthead [title]="t('CO_APP.INVITE.heading')"></op-masthead>

		<div class="co-app-description">
			<div><mat-icon svgIcon="op-star-blue"></mat-icon></div>
			<div>{{ needStrongCredit ? t('CO_APP.INVITE.descriptionCredit') : t('CO_APP.INVITE.descriptionIncome') }}</div>
		</div>

		<op-content-container class="content">
			<form class="co-app-invite-content op-mt-20" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
				<div class="op-header-3">{{ t('CO_APP.INVITE.coAppInfo') }}</div>
				<mat-form-field class="form-element" appearance="outline">
					<mat-label>{{ t('CO_APP.INVITE.firstName') }}</mat-label>
					<input matInput type="text" formControlName="firstName" id="firstName" name="firstName" required />
				</mat-form-field>

				<mat-form-field class="form-element" appearance="outline">
					<mat-label>{{ t('CO_APP.INVITE.lastName') }} </mat-label>
					<input matInput type="text" formControlName="lastName" id="lastName" name="lastName" required />
				</mat-form-field>

				<mat-form-field class="form-element" appearance="outline">
					<mat-label>{{ t('CO_APP.INVITE.phoneNumber') }}</mat-label>
					<input
						matInput
						type="text"
						inputmode="numeric"
						mask="(000) 000-0000"
						required
						name="telephone"
						id="telephone"
						formControlName="phoneNumber"
						[dropSpecialCharacters]="false"
					/>
				</mat-form-field>

				<mat-form-field class="form-element" appearance="outline">
					<mat-label>{{ t('CO_APP.INVITE.emailAddress') }} </mat-label>
					<input matInput type="text" formControlName="emailAddress" id="email" name="email" opMaxLength="100" />
				</mat-form-field>

				<div class="preferred-language">
					<div class="op-form-title op-header-4">
						<op-info-tip
							id="refLangTip"
							[key]="t('PERSONAL_INFO.preferredLanguageTip')"
							ariaLabel="{{ t('TOOLTIP.moreInfo') }}"
						>
							<span id="preferredLangTitle">{{ t('PERSONAL_INFO.preferredLanguage') | opRequired }}</span>
						</op-info-tip>
					</div>
					<div>
						<mat-radio-group [value]="selectedValue" name="preferredLanguage" formControlName="preferredLanguage">
							<mat-radio-button
								labelPosition="before"
								*ngFor="let item of toggleLanguageOptions$ | async; let i = index"
								id="{{ 'preferredLanguage_' + i }}"
								[value]="item.key"
							>
								{{ item.text }}
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>

				<div class="op-center">
					<button
						mat-flat-button
						color="primary"
						name="submitBtn"
						id="submitBtn"
						[disabled]="formGroup?.invalid"
						[opTagClick]="'co-app-invite next'"
						type="submit"
					>
						{{ t('CO_APP.INVITE.sendInvite') }}
					</button>
				</div>
			</form>

			<div class="op-mt-20">
				<op-co-app-common-questions
					id="op-co-app-common-questions"
					[questionType]="questionTypeEnum.INVITE"
				></op-co-app-common-questions>
			</div>
		</op-content-container>
	</div>

	<div class="splash-screen" *ngIf="showSplashScreen">
		<img src="assets/images/send_invitation.svg" alt="Splash Screen" />
		<div class="splash-screen-header op-header-1 op-mb-10">
			{{ t('CO_APP.INVITE.sendingInvite') }}
		</div>
		<div class="splash-screen-subtext">
			{{ t('CO_APP.INVITE.inviteSent') }}
		</div>
	</div>
</div>
